module.exports = __webpack_public_path__ + "img/login_title_test.3966dda1.png";